// Max valid sizes for uploaded photos in mb
export const FILE_SIZES = {
    startScreen: 60,
    print: 5,
    sharing: 2.5,
    scenes: 50,
    pdf: 4,
    gdprDocument: 10,
    favicon: 0.5,
    customLogo: 2
};



// WEBPACK FOOTER //
// ./sources/constants/file-sizes.constant.js